import { message } from 'ant-design-vue';
import mime from 'mime-types';
import { FileTypeEnum, IMAGE_MIMETYPE_ARRAY } from './file-enum';

/**
 * 获取文件数据的类型和拓展名
 * @param {*} fileSize number
 * @returns { string } '基于1024计算，返回单位B, KB, MB'
 */
export const formatFileSize = fileSize => {
  let sizeString = `${fileSize}B`;
  if (fileSize >= 1024) sizeString = `${(fileSize / 1024).toFixed(2)} KB`;
  if (fileSize >= 1024 ** 2)
    sizeString = `${(fileSize / 1024 ** 2).toFixed(2)} MB`;
  return sizeString;
};

/**
 * 获取文件数据的类型和拓展名
 * att!! 这个方法暂时只用于猜测图片类型文件, 因为若猜测其他二进制可能导致后缀异常
 * @param {*} binary blob, file 或者arraybuffer
 * @returns { fileType: FileTypeEnum, mimeType: '', extension: '' }
 */
// export const getBinaryDataInfo = async binary => {
//   let blob, mimeType, extension;
//   if (binary instanceof Blob) {
//     blob = binary;
//     // 若是文件, 我们首先以它的文件名为准去查询
//     if (binary instanceof File) {
//       mimeType = mime.lookup(binary.name);
//       extension = getExtensionByMimeType(mimeType);
//     } else {
//       mimeType = blob.type;
//       extension = getExtensionByMimeType(mimeType);
//     }
//   } else if (isArrayBuffer(binary) || ArrayBuffer.isView(binary)) {
//     blob = new Blob(binary);
//   }
//   if (blob && !mimeType && !extension) {
//     mimeType = blob.type;
//     // 检查mimeType是否存在和正确
//     if (!mimeType || !getExtensionByMimeType(mimeType)) {
//       // 通过magic number去检测类型
//       const [, result] = await to(FileType.fromBlob(blob));
//       // 如果检测成功
//       if (result?.ext && result.mime) {
//         mimeType = result.mime;
//         extension = result.ext;
//       }
//     } else {
//       // 根据mimeType去查询extension
//       extension = getExtensionByMimeType(mimeType);
//     }
//   }
//   if (mimeType && extension) {
//     // 检测类型
//     const fileType = getTeatalkFileTypeByFileName('1.' + extension);
//     return { fileType, mimeType, extension };
//   } else {
//     return {
//       fileType: FileTypeEnum.OTHERS,
//       mimeType: 'application/octet-stream',
//       extension: ''
//     };
//   }
// };

export const getExtensionByMimeType = mimeType => {
  // 我们发现有些特殊的情况, 但是mime库不能很好的处理, 所以封装一层
  if (mimeType === 'text/javascript') {
    return 'js';
  }
  return mime.extension(mimeType);
};

export const getFileExtensionByFileName = (fileName = '') => {
  return fileName.slice(
    (Math.max(0, fileName.lastIndexOf('.')) || Infinity) + 1
  );
};

export const getFileTypeByFileName = fileName => {
  const mimeType = mime.lookup(fileName);
  const ext = getFileExtensionByFileName(fileName); // 获取文件后缀名
  if (!mimeType && !ext) {
    // 可能有些fileName, mime查询不到, 但是有后缀的话, 我们尝试去根据后缀名再归类一次, 比如tgz现在mime-types无法查询，但是我们要归类为压缩文件
    return FileTypeEnum.OTHERS;
  }
  if (mimeType) {
    if (IMAGE_MIMETYPE_ARRAY.includes(mimeType)) {
      return FileTypeEnum.IMAGE;
    } else if (mimeType.startsWith('audio')) {
      return FileTypeEnum.AUDIO;
    } else if (mimeType.startsWith('video')) {
      return FileTypeEnum.VIDEO;
    }
  }
  if (['xlsx', 'xls', 'xlsm'].includes(ext)) {
    // 属于电子表格
    return FileTypeEnum.EXCEL;
  } else if (['doc', 'docx','wps'].includes(ext)) {
    // 属于文稿
    return FileTypeEnum.WORD;
  } else if (['txt', 'md', 'markdown', 'log'].includes(ext)) {
    // 属于文稿
    return FileTypeEnum.TXT;
  } else if (['pdf'].includes(ext)) {
    // 属于文稿
    return FileTypeEnum.PDF;
  } else if (['ppt', 'pptx'].includes(ext)) {
    // 属于演示文稿
    return FileTypeEnum.PPT;
  } else if (['zip', '7z', 'rar', 'gz', 'tgz'].includes(ext)) {
    // 属于压缩文件
    return FileTypeEnum.ZIP;
  } else if (['exe', 'dmg', 'bat', 'sh', 'pkg', 'apk', 'msi'].includes(ext)) {
    // 属于可执行文件
    return FileTypeEnum.OTHERS; //没有exe的图标 分到other类别
  }
  return FileTypeEnum.OTHERS; // 其他分类
};
/**
 * url 请求路径
 * fileName 文件名称(需要后缀)
 * params  参数
 */

//文件导出
export const handleFileExport = response => {

  var fileName = '';
  if (!response.headers['content-disposition']) {
    message.warning('文件下载失败');
    return;
  }
  fileName = decodeURIComponent(
    response.headers['content-disposition'].split('=')[1]
  );
  const data = response.data;
  if (!data) {
    message.warning('文件下载失败');
    return;
  }
  if (data.status && data.status == 1) {
    message.warning('暂无数据');
    return;
  }
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(
      new Blob([data], { type: 'application/vnd.ms-excel' }),
      fileName
    );
  } else {
    const url = window.URL.createObjectURL(
      new Blob([data], { type: 'application/vnd.ms-excel' })
    );
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // 下载完成移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
  }
};
